import { atom, useAtom } from "jotai";
import { useEffect } from "react";
import useRole from "../useRole/useRole";
import useStore from "../../context/useStore";
import useProducerService from "../../services/graal-api/useProducerService";
import useGlobalError from "../useGlobalError/useGlobalError";

const producersAtom = atom([]);
const isLoadingProducersAtom = atom(false);
const hasLoadedProducersAtom = atom(false);

const useGraalProducers = (fetchOnLoad = false) => {
  const [state] = useStore();
  const [producers, setProducers] = useAtom(producersAtom);
  const [isLoadingProducers, setIsLoadingProducers] = useAtom(
    isLoadingProducersAtom
  );
  const [hasLoadedProducers, setHasLoadedProducers] = useAtom(
    hasLoadedProducersAtom
  );
  const { myRole } = useRole();
  const { producerServiceActions } = useProducerService();
  const { globalErrorActions } = useGlobalError();

  useEffect(() => {
    if (fetchOnLoad && producers.length == 0) actions.getProducers();
  }, []);

  const actions = {
    getProducers: () => {
      setIsLoadingProducers(true);
      producerServiceActions
        .getAllProducers()
        .then((data) => {
          setProducers(data.data);
          setIsLoadingProducers(false);
          setHasLoadedProducers(true);
        })
        .catch((err) => {
          if (err.response?.status === 401) {
            globalErrorActions.handleGlobalError(err.response.status, {
              callback: () => {
                actions.getProducers();
              },
            });
          } else {
            setIsLoadingProducers(false);
            setHasLoadedProducers(true);
          }
        });
    },
  };

  const myProducers =
    myRole === "PARTNER"
      ? producers.filter(
          (p) => p.nom_societe === state.auth.user.producer?.company
        )
      : producers;

  return {
    isLoadingProducers,
    hasLoadedProducers,
    producers,
    myProducers,
    actions,
    iAmPartner: myRole === "PARTNER",
  };
};

export default useGraalProducers;
